// ============================================================================
// Live Sessions modal — shows all running devin acp processes
// ============================================================================

import {
  sbSessionsBtn, sbSessionsBadge, sessionsOverlay, sessionsClose, sessionsContent,
} from "./dom.js";
import { wireModal, openModal, closeModal } from "./modal.js";

let liveSessionIdsRef = () => new Set();
let sessionsRef = () => [];
let currentSessionIdRef = () => null;
let sendRef = null;
let loadSessionFromHistoryRef = null;

export function updateSessionsBadge() {
  const count = liveSessionIdsRef().size;
  if (sbSessionsBadge) {
    if (count > 0) {
      sbSessionsBadge.textContent = String(count);
      sbSessionsBadge.classList.remove("hidden");
    } else {
      sbSessionsBadge.classList.add("hidden");
    }
  }
}

export function renderSessionsModal() {
  if (!sessionsContent) return;
  const liveIds = Array.from(liveSessionIdsRef());
  if (liveIds.length === 0) {
    sessionsContent.innerHTML = '<div class="sessions-empty">No live Devin sessions. Start a conversation to begin.</div>';
    return;
  }
  const sessionMap = new Map(sessionsRef().map((s) => [s.sessionId, s]));
  sessionsContent.innerHTML = "";
  for (const sid of liveIds) {
    const s = sessionMap.get(sid);
    const title = s?.displayName || s?.title || sid.slice(0, 16);
    const cwd = s?.cwd || "";
    const isCurrent = sid === currentSessionIdRef();
    const row = document.createElement("div");
    row.className = "session-row";
    const dot = document.createElement("div");
    dot.className = "session-row-dot";
    row.appendChild(dot);
    const info = document.createElement("div");
    info.className = "session-row-info";
    const titleEl = document.createElement("div");
    titleEl.className = "session-row-title";
    titleEl.textContent = title + (isCurrent ? " (current)" : "");
    const metaEl = document.createElement("div");
    metaEl.className = "session-row-meta";
    metaEl.textContent = cwd ? `${sid} · ${cwd}` : sid;
    info.appendChild(titleEl);
    info.appendChild(metaEl);
    row.appendChild(info);
    const actions = document.createElement("div");
    actions.className = "session-row-actions";
    const goBtn = document.createElement("button");
    goBtn.textContent = "Go to";
    goBtn.title = "Open this conversation";
    goBtn.disabled = isCurrent;
    goBtn.onclick = (e) => {
      e.stopPropagation();
      haptic("tap");
      closeModal(sessionsOverlay);
      loadSessionFromHistoryRef(sid);
    };
    actions.appendChild(goBtn);
    const stopBtn = document.createElement("button");
    stopBtn.className = "danger";
    stopBtn.textContent = "Stop";
    stopBtn.title = "Stop the devin acp process";
    stopBtn.onclick = (e) => {
      e.stopPropagation();
      haptic("press");
      stopBtn.disabled = true;
      stopBtn.textContent = "Stopping…";
      sendRef({ type: "stop_session", sessionId: sid });
    };
    actions.appendChild(stopBtn);
    row.appendChild(actions);
    sessionsContent.appendChild(row);
  }
}

/**
 * Initialize the sessions modal.
 * @param {object} deps
 * @param {function} deps.liveSessionIds - () => Set
 * @param {function} deps.sessions - () => Array
 * @param {function} deps.currentSessionId - () => string|null
 * @param {function} deps.send - WebSocket send function
 * @param {function} deps.loadSessionFromHistory - session switch function
 */
export function initSessionsModal(deps) {
  liveSessionIdsRef = deps.liveSessionIds;
  sessionsRef = deps.sessions;
  currentSessionIdRef = deps.currentSessionId;
  sendRef = deps.send;
  loadSessionFromHistoryRef = deps.loadSessionFromHistory;

  if (sbSessionsBtn) {
    sbSessionsBtn.addEventListener("click", () => {
      haptic("tap");
      openModal(sessionsOverlay);
      sendRef({ type: "list_sessions" });
      renderSessionsModal();
    });
  }
  wireModal({ overlay: sessionsOverlay, closeBtn: sessionsClose });
}
